var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.text)+" "+_vm._s(`${_vm.$t('MonthsShort.Jan').toLowerCase()} - ${_vm.$t(`MonthsShort.${_vm.monthTo}`).toLowerCase()}`)+" "+_vm._s(_vm.actualYear)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }